export default __webpack_public_path__ + "static/media/podSzk.7ada7033.svg";